import { createRouter, createWebHistory, type RouteRecordRaw, type RouteLocationNormalized, type NavigationGuardNext } from "vue-router";

import DashboardView from "@/features/dashboard/DashboardView.vue";
import LoginView from "@/features/auth/LoginView.vue";
import ProfileView from "@/features/profile/ProfileView.vue";
import ResetView from "@/features/auth/ResetView.vue";
import SignupView from "@/features/auth/SignupView.vue";
import WalletView from "@/features/wallet/WalletView.vue";
import ExtendedStockView from "@/features/stocks/ExtendedStockView.vue";
import TradeDetails from "@/features/wallet/components/TradeDetails.vue";
import OrderDetails from "@/features/wallet/components/OrderDetails.vue";
import WalletBreakdownByExchange from "@/features/wallet/WalletBreakdownByExchange.vue";
import WalletBreakdownByInstrumentType from "@/features/wallet/WalletBreakdownByInstrumentType.vue";
import TransactionDetails from "@/features/wallet/components/TransactionDetails.vue";
import MessagesView from "@/features/messages/MessagesView.vue";

import store from "@/store";

const routes: Array<RouteRecordRaw> = [
  { path: "/", name: "Dashboard", component: DashboardView, meta: { requiresAuth: true } },
  { path: "/extended/:stockCode/:itemExchangeId/:itemStockCodeSegment?", name: "ExtendedStock", component: ExtendedStockView, props: (route) => ({ stockCode: String(route.params.stockCode || ""), itemExchangeId: String(route.params.itemExchangeId || ""), itemStockCodeSegment: String(route.params.itemStockCodeSegment || "") }), meta: { requiresAuth: true } },

  {
    path: "/login",
    name: "Login",
    component: LoginView,
    props: (route) => ({
      message: Array.isArray(route.query.message) ? String(route.query.message[0] || "") : String(route.query.message || ""),
      messageType: Array.isArray(route.query.messageType) ? String(route.query.messageType[0] || "") : String(route.query.messageType || "")
    })
  },
  { path: "/recover", name: "Reset", component: ResetView },
  { path: "/reset", redirect: "/recover" },
  { path: "/create-account", name: "Signup", component: SignupView },
  { path: "/sign-up", redirect: "/create-account" },

  { path: "/profile", name: "Profile", component: ProfileView, props: true, meta: { requiresAuth: true } },
  { path: "/wallet", name: "Wallet", component: WalletView, props: (route) => ({ latestActiveMenuSelection: route.query.latestActiveMenuSelection ? String(route.query.latestActiveMenuSelection) : null }), meta: { requiresAuth: true } },

  { path: "/wallet/trade/:tradeId", name: "TradeDetails", component: TradeDetails, props: (route) => ({ tradeId: String(route.params.tradeId ?? "") }), meta: { requiresAuth: true } },
  { path: "/wallet/order/:orderId", name: "OrderDetails", component: OrderDetails, props: (route) => ({ orderId: String(route.params.orderId ?? "") }), meta: { requiresAuth: true } },
  { path: "/transaction-details", name: "TransactionDetails", component: TransactionDetails, props: true, meta: { requiresAuth: true } },
  { path: "/wallet/exchange/:exchangeId", name: "WalletBreakdownByExchange", component: WalletBreakdownByExchange, props: (route) => ({ exchangeId: String(route.params.exchangeId ?? "") }), meta: { requiresAuth: true } },
  { path: "/wallet/instrument-type/:groupKey", name: "WalletBreakdownByInstrumentType", component: WalletBreakdownByInstrumentType, props: (route) => ({ groupKey: String(route.params.groupKey ?? "") }), meta: { requiresAuth: true } },

  { path: "/messages", name: "Messages", component: MessagesView, props: true, meta: { requiresAuth: true } },

  // catch-all
  { path: "/:pathMatch(.*)*", redirect: "/login" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
  try {
    if (to.matched.some((record) => record.meta?.requiresAuth)) {
      if (!store.getters["isUserLogged"]) {
        next({ name: "Login" });
        return;
      }
    }
    next();
  } catch (error) {
    console.error(error);
    next({ name: "Login" });
  }
});

export default router;
